import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AccountPage.css";

const AccountPage = () => {
  const [user, setUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });
  const [membership, setMembership] = useState("Basic");
  const [activity, setActivity] = useState([]);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("revoraUser"));
    const storedMembership = localStorage.getItem("revoraMembership");
    const storedActivity = JSON.parse(localStorage.getItem("revoraActivity"));

    if (storedUser) {
      setUser(storedUser);
      setForm({
        name: storedUser.name || "",
        email: storedUser.email || "",
        phone: storedUser.phone || "",
        address: storedUser.address || "",
      });
    }

    setMembership(storedMembership === "Premium" ? "Premium" : "Basic");
    if (storedActivity) setActivity(storedActivity);
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = () => {
    setUser(form);
    localStorage.setItem("revoraUser", JSON.stringify(form));
    setIsEditing(false);
  };

  const handleUpgrade = () => navigate("/join-premium");

  const confirmLogout = () => {
    localStorage.removeItem("revoraUser");
    localStorage.removeItem("revoraMembership");
    localStorage.removeItem("revoraActivity");
    navigate("/login");
  };

  const handleEditCustomization = (activityItem) => {
    if (activityItem.payload) {
      localStorage.setItem("revoraCustomization", JSON.stringify(activityItem.payload));
      navigate("/customize");
    }
  };

  if (!user) {
    return (
      <section className="account-page">
        <div className="account-card">
          <h2>Please log in to view your account.</h2>
        </div>
      </section>
    );
  }

  return (
    <section className="account-page">
      <div className="account-container">
        <div className="account-header">
          <h1 className="header">My Account</h1>
          <p className="welcome-text">Welcome back, {user.name || "User"}!</p>
        </div>

        <div className="account-content">
          <div className="account-info glass-card">
            <h2>Profile Information</h2>
            {isEditing ? (
              <>
                <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name" />
                <input name="email" value={form.email} onChange={handleChange} placeholder="Email" />
                <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" />
                <input name="address" value={form.address} onChange={handleChange} placeholder="Address" />
                <button className="save-btn" onClick={handleSave}>Save</button>
              </>
            ) : (
              <>
                <p><strong>Name:</strong> {user.name || "Not set"}</p>
                <p><strong>Email:</strong> {user.email || "Not set"}</p>
                <p><strong>Phone:</strong> {user.phone || "Not set"}</p>
                <p><strong>Address:</strong> {user.address || "Not set"}</p>
                <p>
                  <strong>Membership:</strong>{" "}
                  {membership === "Premium" ? (
                    <span className="premium-badge">Premium Member ✨</span>
                  ) : (
                    <span className="basic-badge">Basic</span>
                  )}
                </p>

                {membership === "Premium" ? (
                  <p className="cancel-note">
                    To cancel your membership, please visit the{" "}
                    <span onClick={() => navigate("/join-premium")}>Join Premium</span> page.
                  </p>
                ) : (
                  <button className="upgrade-btn" onClick={handleUpgrade}>
                    Upgrade to Premium
                  </button>
                )}

                <div className="action-buttons">
                  <button className="edit-btn" onClick={() => setIsEditing(true)}>Edit Profile</button>
                  <button className="logout-btn" onClick={() => setShowLogoutPopup(true)}>Logout</button>
                </div>
              </>
            )}
          </div>

          <div className="account-activity glass-card">
            <h2>Recent Activity</h2>
            {activity.length === 0 ? (
              <p className="no-activity">No activity yet — your test drives and customizations will appear here.</p>
            ) : (
              <div className="activity-list">
                {activity.map((item, i) => (
                  <div key={i} className="activity-item">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <p><strong>Status:</strong> {item.status}</p>
                    {item.payload && item.title.includes("Customization") && (
                      <button 
                        className="edit-btn" 
                        onClick={() => handleEditCustomization(item)}
                        style={{marginTop: "8px", fontSize: "0.9rem"}}
                      >
                        Edit Customization
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Logout Confirmation Popup */}
      {showLogoutPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <p>Are you sure you want to log out?</p>
            <div className="popup-buttons">
              <button className="yes-btn" onClick={confirmLogout}>Yes</button>
              <button className="no-btn" onClick={() => setShowLogoutPopup(false)}>No</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AccountPage;